import { ITableCell } from "./interfaces";

export const Tcell = (props: { isHead?: boolean; cell: ITableCell }) => {
  const { cell, isHead } = props;

  if (isHead) {
    return (
      <th className={`${cell.className ?? ""}`} style={cell.style} dangerouslySetInnerHTML={{ __html: cell.text.toString() }}></th>
    );
  } else {
    return (
      <td className={`${cell.className ?? ""}`} style={cell.style} dangerouslySetInnerHTML={{ __html: cell.text.toString() }}></td>
    );
  }
};
